"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createPrintBidReceiptInstruction = void 0;
const beet = __importStar(require("@metaplex-foundation/beet"));
const web3 = __importStar(require("@solana/web3.js"));
const printBidReceiptStruct = new beet.BeetArgsStruct([
    ['instructionDiscriminator', beet.uniformFixedSizeArray(beet.u8, 8)],
    ['receiptBump', beet.u8],
], 'PrintBidReceiptInstructionArgs');
const printBidReceiptInstructionDiscriminator = [94, 249, 90, 230, 239, 64, 68, 218];
function createPrintBidReceiptInstruction(accounts, args) {
    const { receipt, bookkeeper, instruction } = accounts;
    const [data] = printBidReceiptStruct.serialize({
        instructionDiscriminator: printBidReceiptInstructionDiscriminator,
        ...args,
    });
    const keys = [
        {
            pubkey: receipt,
            isWritable: true,
            isSigner: false,
        },
        {
            pubkey: bookkeeper,
            isWritable: true,
            isSigner: true,
        },
        {
            pubkey: web3.SystemProgram.programId,
            isWritable: false,
            isSigner: false,
        },
        {
            pubkey: web3.SYSVAR_RENT_PUBKEY,
            isWritable: false,
            isSigner: false,
        },
        {
            pubkey: instruction,
            isWritable: false,
            isSigner: false,
        },
    ];
    const ix = new web3.TransactionInstruction({
        programId: new web3.PublicKey('hausS13jsjafwWwGqZTUQRmWyvyxn9EQpqMwV1PBBmk'),
        keys,
        data,
    });
    return ix;
}
exports.createPrintBidReceiptInstruction = createPrintBidReceiptInstruction;
//# sourceMappingURL=printBidReceipt.js.map